import slugify from "slugify";
import { idKeyByType, pathByType } from "./autocompletev2";

const NAMESPACE = "ct_";


function _getKey(key) {
  return `${NAMESPACE}${key}`;
}

function set(key, value) {
  try {
    const data = JSON.stringify(value);
    localStorage.setItem(_getKey(key), data);
  } catch (e) {
    console.error("Erro ao salvar no localStorage:", e, { key, value });
  }
}

function get(key, fallback = null) {
  try {
    const data = localStorage.getItem(_getKey(key));
    return data ? JSON.parse(data) : fallback;
  } catch (e) {
    console.error("Erro ao recuperar do localStorage:", e, { key });
    return fallback;
  }
}

function append(key, value, maxLength = 100, uniqueField = null, nestedKey = null) {
  let arr = get(key, []);
  if (!Array.isArray(arr)) {
    arr = [];
  }

  if (uniqueField) {
    if (nestedKey) {
      arr = arr.filter(item => item?.[nestedKey]?.[uniqueField] !== value?.[nestedKey]?.[uniqueField]);
    } else {
      arr = arr.filter(item => item?.[uniqueField] !== value?.[uniqueField]);
    }
  }

  arr.push(value);
  if (arr.length > maxLength) {
    arr = arr.slice(-maxLength);
  }
  set(key, arr);
}

function remove(key, value, uniqueField = null, nestedKey = null) {
  let arr = get(key, []);
  if (!Array.isArray(arr)) {
    return;
  }

  let filtered;
  if (uniqueField) {
    if (nestedKey) {
      filtered = arr.filter(item => item?.[nestedKey]?.[uniqueField] !== value?.[uniqueField]);
    } else {
      filtered = arr.filter(item => item?.[uniqueField] !== value?.[uniqueField]);
    }
  } else {
    const valueStr = JSON.stringify(value);
    filtered = arr.filter(item => JSON.stringify(item) !== valueStr);
  }
  set(key, filtered);
}

function mapCityData(place) {

  let label;
  let name;
  let type;

  if (place.city) {
    label = `${place.city} - ${place.uf}`;
    name = place.city;
    type = 'city'
  } else if (place.airport) {
    label = `${place.airport} - ${place.uf}`;
    name = place.airport
    type = 'airport'
  } else {
    label = `${place.beach} - ${place.uf}`;
    name = place.beach
    type = 'beach'
  }

    const uf = place.uf === 'ND' && place.ac ? place.ac : place.uf;
    const slug = slugify(String(name)).replaceAll("-","").toLowerCase();
    const href = `${place[idKeyByType[type]]}/${slug}-${uf.toLowerCase()}`;
  return {
    cid: place.idcity,
    cloc: place.idlocale,
    label: label,
    cname: name,
    uf: place.uf,
    country: place.country,
    iscap: place.capital,
    issea: place.seaside,
    istour: place.tourist,
    isagr: place.agricultural,
    clat: place.latitude,
    clon: place.longitude,
    slug: href
  };

}

function unmapCityData(mapped, type) {
  if (type === 'beach') {
    return {
      idcity: mapped.cid,
      idlocale: mapped.cloc,
      beach: mapped.cname,
      uf: mapped.uf,
      seaside: true,
      latitude: mapped.clat,
      longitude: mapped.clon
    };
  }

  if (type === 'airport') {
    return {
      idcity: mapped.cid,
      idlocale: mapped.cloc,
      airport: mapped.cname,
      uf: mapped.uf,
      latitude: mapped.clat,
      longitude: mapped.clon
    };
  }

  return {
    idcity: mapped.cid,
    idlocale: mapped.cloc,
    city: mapped.cname,
    uf: mapped.uf,
    country: mapped.country,
    capital: mapped.iscap,
    seaside: mapped.issea,
    tourist: mapped.istour,
    agricultural: mapped.isagr,
    latitude: mapped.clat,
    longitude: mapped.clon
  };
}

const LocalStorageHelper = {
  set,
  get,
  append,
  remove,
  mapCityData,
  unmapCityData
};

export default LocalStorageHelper;
